import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=facbec96&scoped=true"
import script from "./patientDetail.vue?vue&type=script&lang=js"
export * from "./patientDetail.vue?vue&type=script&lang=js"
import style0 from "./patientDetail.vue?vue&type=style&index=0&id=facbec96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facbec96",
  null
  
)

export default component.exports